function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPointer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.908,
    height: 40.002,
    viewBox: "0 0 23.908 40.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6452"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41427",
    d: "M1112.829-1367.354c0-.572-.024-1.145 0-1.716a2.142 2.142 0 0 0-1.3-2.183 4.82 4.82 0 0 1-2.325-2.214c-.131-.268-.251-.541-.378-.812-.646-1.375-1.289-2.751-1.94-4.124a2.416 2.416 0 0 1 .456-2.869c.208-.231.415-.465.61-.708a2.629 2.629 0 0 0 .589-2 1.837 1.837 0 0 1 2.111-2.032.815.815 0 0 1 .118.6q.006 2.5 0 4.992a.922.922 0 0 0 .331.832c.22.159.322.116.356-.15a3.141 3.141 0 0 0 .008-.39v-5.07a.8.8 0 0 1 .116-.6v-12.021a2.06 2.06 0 0 1 2.052-2.106 2.037 2.037 0 0 1 2.087 2.062c.008 2.836 0 5.672 0 8.508v.429a2.18 2.18 0 0 1 2.668-1.411 1.939 1.939 0 0 1 1.331 1.164 6 6 0 0 1 .171 1.777c.763-1.328 1.55-1.821 2.52-1.553.9.249 1.675.85 1.668 2.511a3.063 3.063 0 0 1 .532-.825 1.709 1.709 0 0 1 1.944-.361 1.732 1.732 0 0 1 1.1 1.693c.02 1.691.006 3.382.006 5.074 0 1.873-.03 3.747.009 5.62a15.425 15.425 0 0 1-.575 4.5 10.209 10.209 0 0 0-.379 2.649c0 .245-.044.49-.067.735z",
    transform: "translate(-1103.766 1407.355)",
    style: {
      fill: "#eab4ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41428",
    d: "M1143.444-1276.079v6.113c0 .12.063.277-.084.352s-.267 0-.394-.085a.91.91 0 0 1-.462-.832c.01-1.921.006-3.842.006-5.763a2.846 2.846 0 0 1 .934.215z",
    transform: "translate(-1135.633 1297.638)",
    style: {
      fill: "#dda97d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41429",
    d: "M1164.058-1463.759c0-.636.008-1.272 0-1.907 0-.217.062-.285.284-.291.889-.024.889-.032.889.849 0 1.077-.006 2.154 0 3.231 0 .233-.057.311-.3.314-.871.011-.871.021-.871-.832l-.002-1.364z",
    transform: "translate(-1154.757 1465.965)",
    style: {
      fill: "#0b97bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41430",
    d: "M1108.452-1440.763c-.05.06-.088.111-.131.156-.164.167-.337.325-.493.5-.125.14-.213.135-.346 0-.915-.925-1.837-1.842-2.756-2.762-.028-.027-.078-.055-.079-.083-.018-.4.388-.484.556-.748.076-.118.168-.178.307-.037.933.943 1.874 1.879 2.811 2.818.044.044.079.096.131.156z",
    transform: "translate(-1102.034 1446.311)",
    style: {
      fill: "#0b97bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41431",
    d: "M1083.637-1382.966c-.624 0-1.247-.008-1.87 0-.229 0-.315-.055-.319-.3-.015-.872-.025-.872.838-.872 1.052 0 2.1.009 3.157-.006.293 0 .408.059.4.382-.017.794 0 .794-.8.794z",
    transform: "translate(-1081.443 1393.35)",
    style: {
      fill: "#0d98bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41432",
    d: "M1219.4-1382.156c-.624 0-1.249-.009-1.873 0-.24.005-.307-.076-.312-.312-.016-.863-.025-.863.847-.863 1.067 0 2.133.009 3.2-.006.275 0 .351.079.349.351-.005.825.007.825-.806.825z",
    transform: "translate(-1201.932 1392.632)",
    style: {
      fill: "#0c97bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41433",
    d: "M1203.99-1443.872a3.261 3.261 0 0 0 .436.51c.324.252.273.424-.005.691a93.346 93.346 0 0 0-2.479 2.476c-.213.219-.335.272-.572.018-.532-.572-.548-.558.016-1.122l2.313-2.312c.071-.072.151-.136.291-.261z",
    transform: "translate(-1187.517 1446.358)",
    style: {
      fill: "#0c97bb"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointer);
export default __webpack_public_path__ + "static/media/pointer.a0d236683ea3312eb4d8f550af59ea5f.svg";
export { ForwardRef as ReactComponent };